<template>
  <div>
    <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
      :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <router-link :to="'/contact/edit?id=' + props.row.id">
            <a class="btn btn-info text-white margin5">
              Edit
            </a>
          </router-link>
          <a v-on:click="deleteMember(props.row.id)" class="btn btn-danger text-white margin5">
            Hapus
          </a>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <!-- Delete confirmation modal -->
    <div v-if="showDeleteModal" class="modal fade show" tabindex="-1" role="dialog" style="display:block; background: rgba(0,0,0,0.5);">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Konfirmasi</h5>
            <button type="button" class="close" aria-label="Close" @click="closeDeleteModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <b style="font-size: 14px;">Apa ingin menghapus juga data nomor pada kontak ?</b>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="performDelete(false)" :disabled="isDeleting">Tidak</button>
            <button type="button" class="btn btn-danger" @click="performDelete(true)" :disabled="isDeleting">
              <span v-if="isDeleting" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
              <span v-if="isDeleting">Menghapus...</span>
              <span v-else>Ya</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['gid'],
    data() {
      return {
        table: {
          total_records: 0,
          isLoading: true,
          columns: [{
              label: "Nama",
              field: "name",
              //   filterOptions: {
              //     enabled: true,
              //   },
              sortable: false,
              width: "40%",
            },
            {
              label: "Nomor Whatsapp",
              field: "number",
              //   filterOptions: {
              //     enabled: true,
              //   },
              sortable: false,
              width: "40%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "20%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [{
              field: "",
              type: "",
            }, ],
            page: 1,
            limit: 10,
            group_id: this.gid
          },
        },
        showDeleteModal: false,
        deleteTargetId: null,
        isDeleting: false,
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      async deleteMember(id) {
        this.deleteTargetId = id;
        this.showDeleteModal = true;
      },
      closeDeleteModal() {
        this.showDeleteModal = false;
        this.deleteTargetId = null;
      },
      async performDelete(deleteContact) {
        try {
          this.isDeleting = true;
          let response = await this.$store.dispatch("group_member_delete", {
            group_id: this.table.serverParams.group_id,
            id: this.deleteTargetId,
            deleteContact: !!deleteContact,
          });
          this.closeDeleteModal();
          this.loadItems();
          this.$toast.success(response.data.message);
        } catch (err) {
          this.closeDeleteModal();
          this.$toast.error("Server error");
        } finally {
          this.isDeleting = false;
        }
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign({},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange(params) {
        this.updateParams({
          page: params.currentPage
        });
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({
          limit: params.currentPerPage
        });
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [{
            type: params.sortType,
            field: this.table.columns[params.columnIndex].field,
          }, ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        this.loadItems();
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          await this.getGID()
          let response = await this.getFromServer(this.table.serverParams);
          this.table.total_records = response.data.data.total_records;
          this.table.rows = response.data.data.members;
        } catch (err) {
          this.$toast.error("Too many request");
        }
        this.table.isLoading = false
      },
      async getFromServer(param) {
        this.table.serverParams.group_id = await this.getGID()
        return await this.$store.dispatch("group_list_member", param);
      },
      getGID() {
        return this.$props.gid
      }
    },
  };
</script>

<style scoped>
  .margin5 {
    margin: 5px;
  }
</style>